module.exports = __webpack_public_path__ + "img/20190718-stadium-rms.09c9d87d.jpg";